module.exports = __webpack_public_path__ + "img/mega_blue_white.5d81d155.png";